import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import InformOtherJobsService from "../../../../services/informotherjob.service";
import SeqOthersJobsService from "../../../../services/seqothersjob.service";
import WorkOrdersForm from "../../../../components/GeneralJobForm/WorkordersForm";

export default function CreateWorkOrders() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  return (
    <>
      <Helmet>
        <meta name="description" content="Add Create a job notification Page" />
      </Helmet>

      <Container fluid className="p-0">
        <WorkOrdersForm
          onSubmitCallback={(data) =>
            addEditServiceRequest({
              showAlert,
              setLoading,
              serviceRequest: SeqOthersJobsService.createSeqOthersJobs(data),
              callback: ({ generatedMaps }) => {
                addEditServiceRequest({
                  showAlert,
                  setLoading,
                  serviceRequest: InformOtherJobsService.editInformOtherJobs(
                    data?.Job_Other_Id,
                    { Inform_Doc_Status: "CLOSED" }
                  ),
                  navigated: (navi) => navi && navigate(0)
                });
                navigate("/general_job/create", {
                  state: {
                    ...state,
                    type: "workorder",
                    Seq_Other_Id: generatedMaps?.[0]?.Id
                  }
                });
              }
            })
          }
        />
      </Container>
    </>
  );
}
